/*eslint-disable no-unused-expressions*/
import handleMethod from '../Utils/APIutils/handleMethod';

class UserAPI {
  async AzureAuthenticate() {
    const Input = {
      type: 'GET',
      method: `AzureAuthenticate`,
      params: {}
    };

    return handleMethod(Input);
  }

  async Authenticate(email, password) {
    const Input = {
      type: 'POST',
      method: `Authenticate`,
      params: {
        Email: email,
        Password: password
      }
    };

    return handleMethod(Input);
  }

  async listProfiles(page = 1, itemsPerPage = 100) {
    return handleMethod({ type: 'GET', method: `api/Profile?page=${page}&itemsPerPage=${itemsPerPage}` });
  }

  async inviteLocalUser(payload) {
    return handleMethod({
      type: 'POST',
      method: 'api/User/invite',
      params: payload,
    });
  }

  async inviteEntraUser(payload) {
    return handleMethod({ type: 'POST', method: 'api/User/entra-invite', params: payload });
  }

  async bulkInviteLocalUsers(users) {
    return handleMethod({ type: 'POST', method: 'api/User/invite/bulk', params: { users } });
  }

  async bulkInviteEntraUsers(users) {
    return handleMethod({ type: 'POST', method: 'api/User/entra-invite/bulk', params: { users } });
  }

  async GetUsersList(id, filters = []) {
    const request = {
      type: 'GET',
      method: `getUserList`,
      params: {
        roleIDs: id,
        filters: filters
      }
    }

    const response = await handleMethod(request);

    return response;
  }

  async list({
    page = 1,
    itemsPerPage = 100,
    search,
    profile,
    status,
    sortBy,
    sortDirection,
    clientId,
    clientIds,
  } = {}) {
    const params = new URLSearchParams();

    params.set('page', page);
    params.set('itemsPerPage', itemsPerPage);

    if (search) params.set('search', search);
    if (profile) params.set('profile', profile);
    if (sortBy) params.set('sortBy', sortBy);
    if (sortDirection) params.set('sortDirection', sortDirection);
    if (clientIds && clientIds.length > 0) {
      clientIds.forEach((c) => params.append('clientIds', c));
    } else if (clientId) {
      params.set('clientId', clientId);
    }
    if (status && status.length > 0) status.forEach((s) => params.append('status', s));

    return handleMethod({
      type: 'GET',
      method: `api/User?${params.toString()}`,
    });
  }

  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/User/${id}` });
  }

  async remove(id) {
    return handleMethod({ type: 'DELETE', method: `api/User/${id}` });
  }

  async reactivate(id) {
    return handleMethod({ type: 'POST', method: `api/User/${id}/reactivate` });
  }

  async GetUserDetails(username) {
    const searchParams = username && username !== null ? `?username=${username}` : '';
    const Input = {
      type: 'GET',
      method: `GetUserDetails${searchParams}`,
      params: {}
    };

    const response = await handleMethod(Input);
    if (username === "new") {
      response[0].username = null;
    }
    return response;
  }

  async getProfiles(id, filters = []) {
    const Input = {
      type: 'GET',
      method: `getRoles`,
      params: {
        id: id,
        filters: filters
      }
    };

    const response = await handleMethod(Input);

    return response;
  }

  async GetRoleConfiguration(roleID) {
    const searchParams = roleID && roleID !== null ? `?roleIDs=${roleID}` : '';
    const Input = {
      type: 'GET',
      method: `GetRoleConfiguration${searchParams}`,
      params: {}
    };

    const response = await handleMethod(Input);

    if (roleID === "new") {
      return response[0];
    }
    return response;
  }

  async devToken() {
    return handleMethod({ type: 'GET', method: 'DevToken' });
  }

  async getInvitedUser(token) {
    return handleMethod({
      type: 'GET',
      method: `api/User/invite/${token}`,
    });
  }

  async getResetUser(token) {
    return handleMethod({
      type: 'GET',
      method: `api/User/reset-token/${token}`,
    });
  }

  async setPassword(token, password) {
    return handleMethod({
      type: 'POST',
      method: 'api/User/set-password',
      params: { token, password },
    });
  }

  async resetPasswordFromToken(token, password) {
    return handleMethod({
      type: 'POST',
      method: 'api/User/reset-password-from-token',
      params: { token, password },
    });
  }

  async sendPasswordReset(id) {
    return handleMethod({
      type: 'POST',
      method: `api/User/${id}/send-password-reset`,
      params: {},
    });
  }

  async changePassword(currentPassword, newPassword) {
    return handleMethod({
      type: 'POST',
      method: 'api/User/change-password',
      params: { currentPassword, newPassword },
    });
  }

  async assignProfilesToUser(id, profileIds, clientId = null) {
    const method = clientId ? `api/User/${id}/profiles?clientId=${encodeURIComponent(clientId)}` : `api/User/${id}/profiles`;
    return handleMethod({
      type: 'POST',
      method,
      params: profileIds,
    });
  }

  async getUserStores(id) {
    return handleMethod({ type: 'GET', method: `api/User/${id}/stores` });
  }

  async assignStoresToUser(id, storeIds) {
    return handleMethod({
      type: 'POST',
      method: `api/User/${id}/stores`,
      params: storeIds,
    });
  }

  async getNotificationPreferences() {
    return handleMethod({
      type: 'GET',
      method: 'api/User/notification-preferences',
    });
  }

  async updateNotificationPreferences(preferences) {
    return handleMethod({
      type: 'PUT',
      method: 'api/User/notification-preferences',
      params: preferences,
    });
  }

  async getUserNotificationPreferences(id) {
    return handleMethod({
      type: 'GET',
      method: `api/User/${id}/notification-preferences`,
    });
  }

  async updateUserNotificationPreferences(id, preferences) {
    return handleMethod({
      type: 'PUT',
      method: `api/User/${id}/notification-preferences`,
      params: preferences,
    });
  }

  async updateUser(id, payload) {
    return handleMethod({
      type: 'PATCH',
      method: `api/User/${id}`,
      params: payload,
    });
  }
}

export const userAPI = new UserAPI();
